module.exports = __webpack_public_path__ + "img/time.c73256ee.svg";